var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	2143: 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"61":1,"170":1,"319":1,"514":1,"532":1,"653":1,"661":1,"758":1,"1021":1,"1039":1,"1060":1,"1075":1,"1077":1,"1149":1,"1189":1,"1252":1,"1268":1,"1306":1,"1442":1,"1444":1,"1617":1,"1668":1,"1720":1,"1801":1,"1899":1,"2128":1,"2187":1,"2241":1,"2315":1,"2528":1,"2638":1,"2656":1,"2668":1,"2833":1,"2910":1,"2971":1,"2981":1,"3015":1,"3123":1,"3176":1,"3183":1,"3446":1,"3561":1,"3588":1,"3674":1,"3797":1,"3949":1,"3980":1,"4050":1,"4062":1,"4088":1,"4238":1,"4333":1,"4363":1,"4645":1,"4708":1,"4844":1,"4903":1,"5114":1,"5142":1,"5479":1,"5603":1,"5760":1,"5834":1,"5864":1,"5943":1,"6026":1,"6179":1,"6243":1,"6342":1,"6407":1,"6473":1,"6489":1,"6534":1,"6614":1,"6648":1,"6825":1,"6917":1,"7042":1,"7283":1,"7419":1,"7432":1,"7457":1,"7504":1,"7544":1,"7752":1,"7843":1,"7925":1,"7954":1,"8245":1,"8256":1,"8305":1,"8603":1,"8641":1,"8681":1,"8704":1,"8710":1,"8755":1,"8865":1,"8906":1,"8916":1,"9306":1,"9457":1,"9664":1,"9675":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr